import React, { useEffect, useState } from 'react'
import api from '../../api/api'
import { useAppDispatch } from '../../store/store'
import { setLoading } from '../../store/slice/utilSlice'
import { useTranslation } from 'react-i18next'

const ScheduleList = () => {
    const [schedules, setSchedules] = useState([])
    const dispatch = useAppDispatch()
    const { t } = useTranslation()

    useEffect(() => {
        dispatch(setLoading(true))
        api.get(`${process.env.REACT_APP_API_BASE_URL}/schedule/${getCurrentDate()}?mode=week`).then(res => {
            console.log("schedule", res.data.data)
            setSchedules(res.data.data)
        }).catch(err => {
            console.log("err cart", err)
        }).finally  (() => {        
            dispatch(setLoading(false))
        })
    }, [])

    const getCurrentDate = (): string => {
        const today = new Date()
        const year = today.getFullYear()
        const month = String(today.getMonth() + 1).padStart(2, "0")
        const day = String(today.getDate()).padStart(2, "0")
        return `${year}-${month}-${day}`
    }
    
    const getDayOfWeek = (dateString: string): string => {
        const daysOfWeek = [t("sunday"), t("monday"), t("tuesday"), t("wednesday"), t("thursday"), t("friday"), t("saturday")]
        const date = new Date(dateString)
        return daysOfWeek[date.getDay()]
    }      
    
    return (
        <div className="pb-28">
            <div className='mb-2 px-3'>
                <div className='text-lg font-medium'>{t("schedule.upcoming_class")}</div>
            </div>

            <div className="px-3">
                {schedules.map((schedule:any) => (
                    <div className='border-b-2 mb-2'>
                        <div className='text-lg font-semibold'>{getDayOfWeek(schedule.date)}, {schedule.date}</div>
                        {schedule.courses.length > 0 ? schedule.courses.map((course:any) => (
                        <div className='grid grid-cols-6 gap-2  pt-2.5 items-center rounded-3xl mb-3 '>
                            <div className='col-span-1'>
                                {course.images.length > 0 ? (
                                    <img src={course.images[0]} alt="" className='w-10 h-10 rounded-3xl'/>
                                ):(
                                    <img src={ "/assets/img/products/product1.png"} alt="" className='w-10 rounded-3xl'/>
                                )}
                            </div>
                            <div className='col-span-3'>
                                <div className='text-lg font-semibold'>{course.name || "-"}</div>
                                <div className='text-md font-light'>{course.student_name}</div>
                            </div>
                            <div className='col-span-2 text-md font-light text-end self-start'>
                                <div>{course.branch_name}</div>
                                <div>{course.start_time} - {course.end_time}</div>
                                {course.status === "canceled" && (<div className='bg-red-500 w-4/6 sm:w-3/6 md:w-2/6 lg: lg:w-1/5 rounded-2xl text-white text-center ml-auto mt-1'>Cancelled</div>)}
                            </div>
                        </div>
                        )) : (
                            <div className='text-center border rounded-3xl mb-3 mt-2 py-3'>
                                {t("schedule.no_class_today")}
                            </div>
                        )}
                    </div>

                ))}
            </div>
        </div>
    )
}

export default ScheduleList